import type { MemberDto } from "@ied/shared-types";
import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

type CreateMemberBody = Pick<
	MemberDto,
	"first_name" | "last_name" | "email" | "phone" | "groups"
>;

type BatchResponse = Array<{
	status: number;
	body: MemberDto;
}>;

export function useCreateMembersBatch() {
	return useMutation({
		mutationKey: ["members"],
		mutationFn: async (members: CreateMemberBody[]) => {
			const membersWithActive = members.map((member) => ({
				...member,
				is_active: true,
			}));

			const response = await fetch(`${SERVICE_API}/api/members/batch`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify(membersWithActive),
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (!response.ok) {
				throw new Error("Failed to create members");
			}

			return (await response.json()) as BatchResponse;
		},
		onSuccess: (_, __, ___, c) => {
			c.client.invalidateQueries({
				queryKey: ["members"],
			});
		},
	});
}
